export default class AltcraftAnalytics {
  /**
   * @param {String, Array} tags
   * @param {Number} value
   * @param {Object} match
   * @param {Object} update
   * @param {Object} matching_mode
   *
   * @returns {boolean}
   */
  static invokeEvent(tags, value, match, update, matching_mode = null) {
    if (typeof window === 'undefined') {
      return false;
    }

    if (!(window.ak_pixel_push instanceof Function)) {
      console.warn('AltcraftAnalitics: ak_pixel_push function is not defined');
      return false;
    }

    /**
     * @param {Function} window.ak_pixel_push
     */
    window.ak_pixel_push(tags, value, match, update, matching_mode);

    return true;
  }

  static subscribeToEmailChannel(userEmail, resourceId) {
    const update = {
      subscriptions: resourceId && [
        {
          resource_id: +resourceId,
          channel: 'email',
          email: userEmail,
        },
      ],
    };

    this.invokeEvent(
      'user_email_subscribe',
      0,
      { email: userEmail },
      update,
      'email',
    );
  }

  /**
   * @param {Number} price
   * @param {Object} user
   * @param {String} userEmail
   * @param {Boolean} isNewUser
   *
   * @returns {Boolean}
   */
  static firePaymentPopup(price, user, userEmail) {
    const update = {
      // subscriptions: process.env.ALTCRAFT_RESOURCE_DEFAULT_ID && [
      //   {
      //     resource_id: +process.env.ALTCRAFT_RESOURCE_DEFAULT_ID,
      //     channel: 'email',
      //     email: user?.email ?? userEmail,
      //     ...(isNewUser ? { status: 4 } : {}), // Status 4 - невалидная подписка, SKY-5269
      //   },
      // ],
    };

    if (user) {
      update.user_id = user.id;
    }

    this.invokeEvent(
      'cart_open',
      price,
      { email: user?.email ?? userEmail },
      update,
      'email',
    );

    return true;
  }

  /**
   * @param {Object} user
   * @returns {Boolean}
   */
  static firePageView(user) {
    this.invokeEvent(
      'page_visit',
      null,
      { email: user.email },
      { user_id: user.id },
      'email',
    );

    return true;
  }
}
